import { render } from "./CategoryTree.vue?vue&type=template&id=27707c86&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"

import "./CategoryTree.vue?vue&type=style&index=0&id=27707c86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27707c86"

export default script